package org.example.zone360.pages.authentication

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.components.showToast
import com.stevdza.san.kotlinbs.models.ToastPlacement
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.forgetPassword
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.BSToastBasicCustom
import org.example.zone360.components.BSToastGroupCustom
import org.example.zone360.components.CommonButton
import org.example.zone360.components.InputField
import org.example.zone360.componentss.FieldTitleText
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Res
import org.example.zone360.utils.isValidEmail
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Page("/forgot-password")
@Composable
fun ForgotPasswordPage() {
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()
    val sitePalette = ColorMode.current.toSitePalette()

    var emailError by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    var serverMessage by remember { mutableStateOf(" ") }
    var message by remember { mutableStateOf("") }

    fun sendResetCode() {
        scope.launch {
            val emailInput = (document.getElementById(Res.Id.emailInput) as HTMLInputElement).value.trim()

            if (emailInput.isBlank() || !isValidEmail(emailInput)) {
                emailError = true
                serverMessage = "Please enter a valid email address."
                return@launch
            }

            emailError = false
            isLoading = true
            serverMessage = ""

            try {
                val res = forgetPassword(emailInput)
                message = "Email sent successfully!"
                showToast("toastSuccess")
            } catch (t: Throwable) {
                emailError = true
                message = "Something went wrong. Please try again."
                showToast("toastError")
                serverMessage = t.message ?: "Something went wrong. Please try again."
            } finally {
                isLoading = false
            }
        }
    }

    Box(Modifier.fillMaxSize()) {

        BSToastGroupCustom(
            placement = ToastPlacement.TopRight,
        ) {
            BSToastBasicCustom(id = "toastSuccess",
                text = message,
                style = ToastStyle.Success,
                autoHide = true,
                closeButtonDark = false,
                onCloseClick = {})
            BSToastBasicCustom(id = "toastError",
                text = message,
                style = ToastStyle.Danger,
                autoHide = true,
                closeButtonDark = false,
                onCloseClick = {})
        }
    Box(
        Modifier.fillMaxSize().color(sitePalette.bodyBackground.rgb),
        contentAlignment = Alignment.Center
    ) {
        Box(
            Modifier
                .color(Colors.Black)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .maxWidth(400.px)
                .borderRadius(6.px),
            contentAlignment = Alignment.Center
        ) {
            Column(modifier = Modifier.padding(topBottom = 40.px, leftRight = 30.px)) {
                FieldTitleText(text = "Forgot Password?", textAlign = TextAlign.Center, marginBottom = 10.px)
                Row(modifier = Modifier.display(DisplayStyle.Flex)){
                FieldTitleTextNormalSimple(
                    text = "Enter your registered email address to receive a verification code.",
                    fontSize = 13.px,
                    color = sitePalette.textFieldTextColor.rgb,
                    marginBottom = 15.px,
                    textAlign = TextAlign.Center,
                    onClick = {}
                )}

                Spacer()
                FieldTitleTextNormal(text = "Email") {}
                InputField(
                    errorText = "Please enter a valid email (e.g. name@domain.com).",
                    inputType = InputType.Email,
                    placeHolder = "Enter Email Address",
                    id = Res.Id.emailInput,
                    isError = emailError,
                    marginBottom = 3.px,
                    onEnterPress = { sendResetCode() }
                )

                Box(Modifier.margin(topBottom = 10.px)) { }

                CommonButton(
                    byPassEmailVerification = true,
                    text = "Reset password",
                    isLoading = isLoading,
                    onCLick = { sendResetCode() }
                )

                Box(
                    modifier = Modifier.margin(top = 15.px).fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = "Back to Login",
                        fontSize = 13.px,
                        color = sitePalette.primary.rgb,
                        isClickable = true,
                        onClick = { context.router.navigateTo("/login") }
                    )
                }
            }
        }
    }}
}

